import { deepMerge } from '@websolutespa/bom-core';
import theme from './theme.json.js';

const DEFAULT_THEME = theme;
function getThemes(overrides, defaultTheme) {
  if (overrides === void 0) {
    overrides = [];
  }
  let theme = defaultTheme ? Object.assign({}, defaultTheme) : Object.assign({}, DEFAULT_THEME);
  overrides.forEach(override => {
    theme = deepMerge(theme, Object.assign({}, override));
  });
  return theme;
}

export { DEFAULT_THEME, getThemes };
//# sourceMappingURL=theme.js.map
